require('./riskLevelBar.scss');
const PropTypes = require('prop-types');
const React = require('react');
const SquaresRow = require('./squaresRow');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

const RiskLevelBar = props => {
    const { riskLevel, maxLevel } = props;
    const tooltipText = `${riskLevel}/${maxLevel}`;
    const riskLevelBar = (
        <div className="risk-level-bar">
            <SquaresRow maximum={maxLevel} level={riskLevel} />
        </div>
    );
    return (
        <OKTooltip
            target={riskLevelBar}
            content={tooltipText}
            type="descriptive"
            offset={[0, -12]}
        />
    );
};

RiskLevelBar.propTypes = {
    riskLevel: PropTypes.number,
    maxLevel: PropTypes.number
}

module.exports = RiskLevelBar;
